import styles from './Header.module.scss';
import React, { useState } from "react";
import clsx from 'clsx';

const Header = (props) => {

  const [menuIcon, setMenuIcon] = useState("menubars");
  let toggleIcon = menuIcon ? 'menubars' : 'x';

  function handleClick(){
    setMenuIcon(menuIcon => !menuIcon);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const changeLanguage = () => {
    const newLanguage = props.language === 'eng' ? 'pl' : 'eng';
    props.setLanguage(newLanguage);
  }
  
  return (
    <>
    <div className={styles.header}>
      <div className={styles.headerGapLeft}></div>

      <div className={styles.logoHeaderDiv} onClick={scrollToTop}>
        <img className={styles.headerLogo} alt="CometwebLogo" src={`${process.env.PUBLIC_URL}/header/whitelogoresized.png`}></img>
      </div>

      <div className={styles.menuHeaderDiv}>
        <div className={styles.menuGap}></div>

        <div className={styles.box}>
          {props.language === 'pl' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja1')}>Strony internetowe</p>
          }
          {props.language === 'eng' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja1')}>Websites</p>
          }
          <span className={styles.underlineWhite}></span>
        </div>

        <div className={styles.menuGap}></div>

        <div className={styles.box}>
          {props.language === 'pl' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja2')}>Aplikacje Webowe</p>
          }
          {props.language === 'eng' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja2')}>Web applications</p>
          }
          <span className={styles.underlineWhite}></span>
        </div>

        <div className={styles.menuGap}></div>

        <div className={styles.box}>
          {props.language === 'pl' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja3')}>Vulnerability testy</p>
          }
          {props.language === 'eng' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja3')}>Vulnerability tests</p>
          }
          <span className={styles.underlineWhite}></span>
        </div>

        <div className={styles.menuGap}></div>

        {/* <div className={styles.box}>
          <p className={styles.menuOptions}>Portfolio</p>
          <span className={styles.underlineWhite}></span>
        </div> */}

        {/* <div className={styles.menuGap}></div> */}

        <div className={styles.box}>
          {props.language === 'pl' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja4')}>Kontakt</p>
          }
          {props.language === 'eng' &&
            <p className={styles.menuOptions} onClick={() => props.scrollToSection('sesja4')}>Contact</p>
          }
          <span className={styles.underlineWhite}></span>
        </div>
      </div>

      <div className={styles.flagWrapper}>
        <img className={styles.flag} alt="CometwebLogo" onClick={changeLanguage} src={`${process.env.PUBLIC_URL}/flags/${props.language}.png`}></img>
      </div>

      <div className={styles.headerMenuBars} onClick={()=>{
        handleClick();
      }}>
        <img className={styles.menuBars} alt="CometwebLogo" src={`${process.env.PUBLIC_URL}/icons/${toggleIcon}.png`}></img>
      </div>

      <div className={styles.flagWrapperTab}>
        <img className={styles.flag} alt="CometwebLogo" onClick={changeLanguage} src={`${process.env.PUBLIC_URL}/flags/${props.language}.png`}></img>
      </div>

      <div className={styles.headerGapRight}></div>
    </div>

    {/* <div className={styles.flagWrapperTab}>
      <img className={styles.flag} alt="CometwebLogo" src={`${process.env.PUBLIC_URL}/flags/pl.png`}></img>
    </div> */}

      <div className={clsx(toggleIcon === 'x' && styles.wholeMenu, toggleIcon === 'menubars' && styles.hiddenMenu)}>

        <div className={clsx(toggleIcon === 'x' && styles.toggleMenuDiv, toggleIcon === 'menubars' && styles.toggleMenuDivHidden)}>
          <div className={styles.toggleMenuOptionDiv}>
            <p className={styles.toggleMenuOptions}>Strony i aplikacje webowe</p>
            <span className={styles.underlineWhite}></span>
          </div>

          <div className={styles.toggleMenuOptionDiv}>
            <p className={styles.toggleMenuOptions}>Social media marketing</p>
            <span className={styles.underlineWhite}></span>
          </div>

          <div className={styles.toggleMenuOptionDiv}>
            <p className={styles.toggleMenuOptions}>Vulnerability testy</p>
            <span className={styles.underlineWhite}></span>
          </div>

          <div className={styles.toggleMenuOptionDiv}>
            <p className={styles.toggleMenuOptions}>Portfolio</p>
            <span className={styles.underlineWhite}></span>
          </div>

          <div className={styles.toggleMenuOptionDiv}>
            <p className={styles.toggleMenuOptions}>Kontakt</p>
            <span className={styles.underlineWhite}></span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;